export default "__VITE_ASSET__D4x4H5B9__"